module.exports = __webpack_public_path__ + "img/agent-show-tool.0369f04a.png";